<template>
  <div class="page-main">
    <div class="flex flex-y-center flex-x-between m-b-10">
      <div class="flex flex-y-center">
        <el-button
          type="success"
          size="mini"
          icon="el-icon-plus"
          @click="itemDoOrder()"
        >新增采购订单</el-button>
        <el-dropdown class="m-l-10">
          <el-button type="default" size="mini">
            批量操作<i class="el-icon-arrow-down el-icon--right"></i>
          </el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item @click.native="batchDelete">
              <span class="c-red">删除</span>
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <el-form class="flex flex-y-center m-l-10" @submit.native.prevent="searchListData">
          <span>下单日期:</span>
          <e-date-picker
            type="daterange"
            :value.sync="order_date"
            isShowFast
            @change="searchListData"
          />
        </el-form>
        <el-button
          size="mini"
          icon="el-icon-refresh"
          class="m-l-10"
          :disabled="!hasFilter"
          @click="resetFilter"
        >重置筛选</el-button>
      </div>
    </div>
    <vxe-grid
      ref="refTable"
      :show-footer="!!tableData.length"
      :loading="loading"
      :columns="tableColumn"
      :data="tableData"
      :height="this.$util.getViewHeight() - 36 - 148"
      :footer-method="footerMethod"
      :cell-class-name="cellClassName"
      @cell-dblclick="itemDbDo"
      @resizable-change="handleColumnResize"
      @keydown="tableKeydown"
      @current-change="tableCurrentChange"
    >
      <!-- 表头筛选 -->
      <template #header_input="{ column }">
        <c-table-header
          :title="column.title"
          :field="column.field"
          :url="headerFilterUrl"
          :filterData="filterData"
          :value="filterData[column.field]"
          placeholder="输入关键字"
          @change="headerFilterChange"
        />
      </template>
      <!-- 是否已打印-筛选 -->
      <template #header_is_print="{ column }">
        <div class="header-filter-box">
          <div>{{ column.title }}</div>
          <el-select
            v-model="filterData.is_print"
            size="mini"
            placeholder="全部"
            clearable
            style="width: 80px"
            @change="searchListData"
          >
            <el-option label="已打印" value="1" />
            <el-option label="未打印" value="0" />
          </el-select>
        </div>
      </template>

      <!-- 单元格 -->
      <template #default_order_code="{ row }">
        <el-link type="primary" @click="itemDoOrder(row.order_code)">
          {{ row.order_code }}
        </el-link>
      </template>
      <template #default_status_str="{ row }">
        <el-tag :type="statusTagType(row.status)" size="mini" plain>{{ row.status_str }}</el-tag>
      </template>
      <template #default_order_date="{ row }">
        {{ row.order_date_str || (row.order_date ? row.order_date.slice(0, 10) : '') }}
      </template>
      <template #default_create_date_str="{ row }">
        {{ row.create_date_str || (row.create_date ? row.create_date.slice(0, 10) : '') }}
      </template>
      <template #default_jiao_huo_date_str="{ row }">
        {{ row.jiao_huo_date_str || (row.jiao_huo_date ? row.jiao_huo_date.slice(0, 10) : '') }}
      </template>
      <template #default_shen_qing_ren_name="{ row }">
        <div>{{ row.shen_qing_ren_name }}</div>
        <div v-if="row.shen_qing_bu_men_name" class="c-gray">({{ row.shen_qing_bu_men_name }})</div>
      </template>
      <template #default_list_chan_pin_tu="{ row }">
        <e-upload-image v-if="row.list_chan_pin_tu" :list.sync="row.list_chan_pin_tu" disabled />
      </template>
      <template #default_order_amount="{ row }">
        <span class="c-orange">{{ row.order_amount }}</span>
      </template>
      <template #default_in_counts="{ row }">
        <span :class="Number(row.in_counts) > 0 ? 'c-green' : ''">{{ row.in_counts }}</span>
      </template>
      <template #default_is_print="{ row }">
        <el-tag v-if="row.is_print" type="success" size="mini">已打印</el-tag>
        <el-tag v-else type="danger" size="mini">未打印</el-tag>
      </template>
      <template #default_operate="{ row }">
        <el-dropdown>
          <el-button type="default" size="mini">
            操作<i class="el-icon-arrow-down el-icon--right"></i>
          </el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item v-if="canEdit(row)" @click.native="itemDoOrder(row.order_code)">
              <span class="c-blue">编辑</span>
            </el-dropdown-item>
            <el-dropdown-item
              v-if="canSubmit(row) && $tool.hasControl(['/caiGouDingDan/submit'])"
              @click.native="itemSubmit(row)"
            >
              <span class="c-blue">提交</span>
            </el-dropdown-item>
            <el-dropdown-item
              v-if="canAudit(row) && $tool.hasControl(['/caiGouDingDan/audit'])"
              @click.native="itemAudit(row)"
            >
              <span class="c-green">审核</span>
            </el-dropdown-item>
            <el-dropdown-item
              v-if="canUnaudit(row) && $tool.hasControl(['/caiGouDingDan/unaudit'])"
              @click.native="itemUnaudit(row)"
            >
              <span class="c-blue">反审核</span>
            </el-dropdown-item>
            <el-dropdown-item
              v-if="canCancel(row) && $tool.hasControl(['/caiGouDingDan/cancel'])"
              @click.native="itemCancel(row)"
            >
              <span class="c-gray">作废</span>
            </el-dropdown-item>
            <el-dropdown-item
              v-if="isAdmin && canEdit(row)"
              @click.native="itemDelete({ ids: [row.a_id], codes: [row.order_code] })"
            >
              <span class="c-red">删除</span>
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </template>

      <template #pager>
        <div></div>
        <vxe-pager v-bind="pageOptions" @page-change="pageChange" />
      </template>
    </vxe-grid>

    <!-- 弹窗-新增/编辑采购订单 -->
    <PopupOrderDo
      v-if="isShowPopupOrderDo"
      :show.sync="isShowPopupOrderDo"
      :code="activeCode"
      @success="updatePage"
    />
  </div>
</template>

<script>
export default {
  tableName: 'new_purchase_order_page_list',
  components: {
    PopupOrderDo: () => import('../common/popup-do')
  },
  data() {
    return {
      loading: true,
      // 下单日期区间
      order_date: [],
      filterData: {
        order_code: '',
        cai_gou_type: '',
        status_str: '',
        shen_qing_ren_name: '',
        shen_qing_bu_men_name: '',
        source_type: '',
        source_bill_code: '',
        bill_code: '',
        gong_cheng_fu_ze_ren_name: '',
        pmc_fu_ze_ren_name: '',
        ke_fu_name: '',
        supplier_name: '',
        supplier_fu_ze_ren: '',
        supplier_phone: '',
        name: '',
        wu_liao_type: '',
        spec: '',
        unit: '',
        counts: '',
        order_counts: '',
        in_counts: '',
        goods_price: '',
        order_amount: '',
        remark: '',
        is_print: ''
      },
      sortData: {
        create_date: 'desc',
        a_id: 'desc'
      },
      tableData: [],
      pageOptions: {
        ...this.$constant.page
      },
      totalObj: {
        total_counts_all: '',
        total_amount_all: ''
      },
      isShowPopupOrderDo: false,
      activeCode: null
    }
  },
  computed: {
    hasFilter() {
      let result = Object.keys(this.filterData).some((key) => {
        let val = this.filterData[key]
        return val !== '' && val !== null && val !== undefined
      })
      return result
    },
    isAdmin() {
      return this.$store.getters.getRoleObj.isAdmin
    },
    // 表头联想接口
    headerFilterUrl() {
      return '/admin/gcvip/caiGouDingDan/searchHeard'
    },
    tableColumn() {
      let result = [
        { fixed: 'left', type: 'checkbox', width: 40 },
        { fixed: 'left', title: '序号', type: 'seq', width: 40 },
        {
          fixed: 'left',
          title: '采购订单号',
          field: 'order_code',
          width: 130,
          slots: { header: 'header_input', default: 'default_order_code' }
        },
        {
          title: '采购类型',
          field: 'cai_gou_type',
          width: 90,
          slots: { header: 'header_input' }
        },
        {
          title: '状态',
          field: 'status_str',
          width: 90,
          slots: { header: 'header_input', default: 'default_status_str' }
        },
        {
          title: '下单日期',
          field: 'order_date',
          width: 100,
          slots: { default: 'default_order_date' }
        },
        {
          title: '创建日期',
          field: 'create_date_str',
          width: 100,
          slots: { header: 'header_input', default: 'default_create_date_str' }
        },
        {
          title: '申请人',
          field: 'shen_qing_ren_name',
          width: 110,
          slots: { header: 'header_input', default: 'default_shen_qing_ren_name' }
        },
        {
          title: '交货日期',
          field: 'jiao_huo_date_str',
          width: 100,
          slots: { header: 'header_input', default: 'default_jiao_huo_date_str' }
        },
        {
          title: '来源类型',
          field: 'source_type',
          width: 90,
          slots: { header: 'header_input' }
        },
        {
          title: '来源申请单号',
          field: 'source_bill_code',
          width: 130,
          slots: { header: 'header_input' }
        },
        {
          title: '销售单号',
          field: 'bill_code',
          width: 110,
          slots: { header: 'header_input' }
        },
        {
          title: '工程负责人',
          field: 'gong_cheng_fu_ze_ren_name',
          width: 100,
          slots: { header: 'header_input' }
        },
        {
          title: 'PMC负责人',
          field: 'pmc_fu_ze_ren_name',
          width: 100,
          slots: { header: 'header_input' }
        },
        { title: '客服', field: 'ke_fu_name', width: 90, slots: { header: 'header_input' } },
        { title: '供应商', field: 'supplier_name', slots: { header: 'header_input' } },
        {
          title: '供应商负责人',
          field: 'supplier_fu_ze_ren',
          width: 100,
          slots: { header: 'header_input' }
        },
        {
          title: '供应商电话',
          field: 'supplier_phone',
          slots: { header: 'header_input' }
        },
        {
          title: '物料图片',
          field: 'list_chan_pin_tu',
          slots: { default: 'default_list_chan_pin_tu' },
          width: 63
        },
        { title: '物料名称', field: 'name', slots: { header: 'header_input' } },
        { title: '物料类型', field: 'wu_liao_type', slots: { header: 'header_input' } },
        { title: '规格(mm)', field: 'spec', width: 120, slots: { header: 'header_input' } },
        { title: '单位', field: 'unit', slots: { header: 'header_input' } },
        {
          title: '需求数量',
          field: 'counts',
          width: 90,
          slots: { header: 'header_input' }
        },
        {
          title: '下单数量',
          field: 'order_counts',
          width: 90,
          slots: { header: 'header_input' }
        },
        {
          title: '已入库数量',
          field: 'in_counts',
          width: 90,
          slots: { default: 'default_in_counts' }
        },
        { title: '单价(元)', field: 'goods_price', slots: { header: 'header_input' } },
        {
          title: '金额(元)',
          field: 'order_amount',
          slots: { header: 'header_input', default: 'default_order_amount' }
        },
        { title: '备注', field: 'remark', width: 160, slots: { header: 'header_input' } },
        {
          fixed: 'right',
          title: '是否已打印',
          field: 'is_print',
          width: 110,
          slots: { header: 'header_is_print', default: 'default_is_print' }
        },
        {
          fixed: 'right',
          title: '操作',
          field: 'operate',
          slots: { default: 'default_operate' },
          width: 73
        }
      ]
      this.$util.initTableColumnWidth(this.$options.tableName, result, 'inherit')
      return result
    }
  },
  mounted() {
    this.getListData()
  },
  methods: {
    handleColumnResize({ column }) {
      this.$util.setTableColumnWidth(this.$options.tableName, column.field, column.resizeWidth)
    },
    updatePage() {
      this.searchListData()
    },
    headerFilterChange(obj) {
      this.filterData[obj.field] = obj.value
      this.searchListData()
    },
    resetFilter() {
      this.resetFilterData()
      this.searchListData()
    },
    resetFilterData() {
      Object.keys(this.filterData).forEach((key) => {
        this.filterData[key] = ''
      })
      this.order_date = []
    },
    searchListData() {
      this.pageOptions.currentPage = 1
      this.getListData()
    },
    getListData() {
      this.loading = true
      let params = {
        currentPage: this.pageOptions.currentPage,
        pageSize: this.pageOptions.pageSize,
        order_date: this.order_date || [],
        filterData: this.filterData,
        sortData: this.$util.deepCopy(this.sortData)
      }
      this.$api({
        method: 'post',
        url: '/admin/gcvip/caiGouDingDan/list',
        data: params
      })
        .then((res) => {
          if (res.data.state === 'ok') {
            let data = res.data.page
            this.tableData = this.$util.deepCopy(data.list) || []
            this.pageOptions.pageSize = data.pageSize
            this.pageOptions.total = data.totalRow
            this.pageOptions.currentPage = data.pageNumber
            this.totalObj.total_counts_all = res.data.total_counts_all
            this.totalObj.total_amount_all = res.data.total_amount_all
          }
        })
        .catch(() => {})
        .then(() => {
          this.loading = false
        })
    },
    pageChange({ currentPage, pageSize }) {
      this.pageOptions.currentPage = currentPage
      this.pageOptions.pageSize = pageSize
      this.getListData()
    },
    getCheckboxRecords() {
      return this.$refs.refTable.getCheckboxRecords()
    },
    tableCurrentChange(params) {
      this.$refs.refTable.setCheckboxRow(params.row, true)
    },
    tableKeydown(params) {
      if (params.$event.code === 'Space') {
        let row = this.$refs.refTable.getCurrentRecord()
        if (!row) return
        let isCurrentRowCheckbox = this.$refs.refTable.isCheckedByCheckboxRow(row)
        this.$refs.refTable.setCheckboxRow(row, !isCurrentRowCheckbox)
      }
    },
    itemChoosePrompt() {
      this.$tool.tableChoosePrompt()
    },
    footerMethod({ columns }) {
      return [
        columns.map((column, columnIndex) => {
          if (columnIndex === 0) return '合计'
          if (column.field === 'order_counts') return this.totalObj.total_counts_all
          if (column.field === 'order_amount') return this.totalObj.total_amount_all
        })
      ]
    },
    cellClassName(rowData) {
      return this.$tool.getTableCellClassName(this.tableData, rowData, 'order_code')
    },
    itemDoOrder(code = null) {
      this.activeCode = code
      this.isShowPopupOrderDo = true
    },
    itemDbDo(val) {
      this.itemDoOrder(val.row.order_code)
    },
    statusTagType(status) {
      if (status === 2) return 'success'
      if (status === 1) return 'warning'
      return 'info'
    },
    canEdit(row) {
      return row.status === 0 || row.status === 1
    },
    canSubmit(row) {
      return row.status === 0
    },
    canAudit(row) {
      return row.status === 0 || row.status === 1
    },
    canUnaudit(row) {
      return row.status === 2
    },
    canCancel(row) {
      return row.status === 0 || row.status === 1
    },
    // 项-提交
    itemSubmit(row) {
      this.$confirm(`确定提交采购订单"${row.order_code}"吗?`, '提示')
        .then(() => {
          this.$api({
            method: 'get',
            url: '/admin/gcvip/caiGouDingDan/submit',
            params: { id: row.a_id }
          })
            .then((res) => this.handleActionRes(res, '提交成功'))
            .catch(() => {})
        })
        .catch(() => {})
    },
    // 项-审核
    itemAudit(row) {
      this.$confirm(`确定审核采购订单"${row.order_code}"吗?`, '提示')
        .then(() => {
          this.$api({
            method: 'get',
            url: '/admin/gcvip/caiGouDingDan/audit',
            params: { id: row.a_id }
          })
            .then((res) => this.handleActionRes(res, '审核成功'))
            .catch(() => {})
        })
        .catch(() => {})
    },
    // 项-反审核
    itemUnaudit(row) {
      this.$confirm(`确定反审核采购订单"${row.order_code}"吗?`, '提示')
        .then(() => {
          this.$api({
            method: 'get',
            url: '/admin/gcvip/caiGouDingDan/unaudit',
            params: { id: row.a_id }
          })
            .then((res) => this.handleActionRes(res, '反审核成功'))
            .catch(() => {})
        })
        .catch(() => {})
    },
    // 项-作废
    itemCancel(row) {
      this.$confirm(`确定作废采购订单"${row.order_code}"吗?`, '提示')
        .then(() => {
          this.$api({
            method: 'get',
            url: '/admin/gcvip/caiGouDingDan/cancel',
            params: { id: row.a_id }
          })
            .then((res) => this.handleActionRes(res, '作废成功'))
            .catch(() => {})
        })
        .catch(() => {})
    },
    // 批量-删除
    batchDelete() {
      let rows = this.getCheckboxRecords()
      if (!rows.length) {
        this.itemChoosePrompt()
        return
      }
      if (rows.some((r) => !this.canEdit(r))) {
        this.$message.warning('存在已审核/已作废单据，无法删除')
        return
      }
      let ids = [...new Set(rows.map((item) => item.a_id))]
      let codes = [...new Set(rows.map((item) => item.order_code))]
      this.itemDelete({ ids, codes })
    },
    // 项-删除
    itemDelete(obj) {
      this.$confirm(`您确定要删除编码为"${obj.codes.join(',')}"的采购订单吗?`, '提示')
        .then(() => {
          this.$api({
            method: 'get',
            url: '/admin/gcvip/caiGouDingDan/delete',
            params: { ids: obj.ids.join(',') }
          })
            .then((res) => {
              if (res.data.state === 'ok') {
                this.$message.success('操作成功')
                this.getListData()
              } else if (res.data.msg) {
                this.$message.error(res.data.msg)
              }
            })
            .catch(() => {})
        })
        .catch(() => {})
    },
    handleActionRes(res, okMsg) {
      if (res.data.state === 'ok') {
        this.$message.success(res.data.msg || okMsg)
        this.getListData()
      } else if (res.data.msg) {
        this.$message.error(res.data.msg)
      }
    }
  }
}
</script>

<style lang="less" scoped>
.page-main {
}
// 是否已打印-表头筛选容器
.header-filter-box {
  color: @colorGrayDeep;
  .el-select {
    margin-top: 2px;
    /deep/ .el-input__inner {
      height: 24px;
      line-height: 24px;
      color: @colorGrayDeep;
      width: 100% !important;
      overflow: hidden;
      padding: 0 2px;
      text-align: center;
    }
    /deep/ .el-input__icon {
      width: auto;
      line-height: 24px;
    }
    /deep/ .el-input__suffix-inner {
      background: #fff;
    }
  }
}
</style>
